import { applyEdgeChanges, applyNodeChanges } from 'reactflow';
import { CanvasState, CanvasAction } from './CanvasState';
import { CanvasEdge } from '../Canvas';

export const CanvasReducer = (state: CanvasState, action: CanvasAction): CanvasState => {
  switch (action.type) {
    case 'ON-NODE-CHANGE': {
      const { changes } = action.payload;

      const nodes = applyNodeChanges(changes, state.nodes as any);

      const nodesArray = nodes.map(s => {
        if (s.id === 'trigger') {
          return s;
        }
        return { ...s };
      });

      return {
        ...state,
        nodes: nodesArray,
      };
    }

    case 'ON-EDGE-CHANGE': {
      const { changes } = action.payload;

      const edgeArray = applyEdgeChanges(changes, state.edges) as CanvasEdge[];

      return {
        ...state,
        edges: [...edgeArray],
      };
    }

    case 'INIT': {
      const payload = action.payload;

      return payload;
    }

    case 'UPDATE': {
      const { nodes, edges } = action.payload;

      return {
        ...state,
        edges,
        nodes,
      };
    }

    case 'HIDE_INTRO_VARIANT': {
      return {
        ...state,
        showIntroVariant: false,
      };
    }

    default:
      return state;
  }
};
